export default {
  treeGreen: {
    100: "#48D549",
    200: "#33D034",
    300: "#2CBF2D",
    400: "#28AE29",
    500: "#249e25",
    600: "#208E21",
    700: "#1D801E",
    800: "#1A731B",
    900: "#176818",
  },
  purplishRed: {
    100: "#F50E66",
    200: "#E3095C",
    300: "#CE0854",
    400: "#BB074C",
    500: "#aa0645",
    600: "#99053E",
    700: "#8A0538",
    800: "#7C0432",
    900: "#70042D",
  },
  squash: {
    100: "#F9D095",
    200: "#F7C173",
    300: "#F5B354",
    400: "#F3A638",
    500: "#f29a1e",
    600: "#E78D0D",
    700: "#D07F0C",
    800: "#BB720B",
    900: "#A8670A",
  },
  greyishBrown: {
    100: "#5E5E5E",
    200: "#555555",
    300: "#4D4D4D",
    400: "#464646",
    500: "#404040",
    600: "#3A3A3A",
    700: "#343434",
    800: "#2F2F2F",
    900: "#2A2A2A",
  },
  revell: {
    100: "#ffffff",
    200: "#ffffff",
    300: "#ffffff",
    400: "#ffffff",
    500: "#eeeeee",
    600: "#D6D6D6",
    700: "#C1C1C1",
    800: "#AEAEAE",
    900: "#9D9D9D",
  },
  nightRider: {
    100: "#484848",
    200: "#414141",
    300: "#3B3B3B",
    400: "#363636",
    500: "#313131",
    600: "#2C2C2C",
    700: "#282828",
    800: "#242424",
    900: "#202020",
  },
}
